import { template as template_ca6e0d3e165a4877831c2a6d8ce43ea9 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { isTesting } from '@embroider/macros';
import RouteTemplate from 'ember-route-template';
import CardPrerender from '@cardstack/host/components/card-prerender';
interface ApplicationRouteSignature {
    Args: {
    };
}
const showCardPrerender = isTesting();
const ApplicationRouteComponent: TemplateOnlyComponent<ApplicationRouteSignature> = template_ca6e0d3e165a4877831c2a6d8ce43ea9(`
    {{outlet}}

    {{! this is used to establish a prerenderer for browser-based indexing }}
    {{#if showCardPrerender}}
      <CardPrerender />
    {{/if}}
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(ApplicationRouteComponent);
